import { Popconfirm, Switch, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

// the switch is labelled and described by elements ProcessingSwitch renders with these ids
export const LABEL_ID = 'vin-processing-switch-label';
export const HELP_ID = 'vin-processing-switch-help';

/** The switch behind its confirm; while the env kill switch is off it sits in a focusable span with a tooltip. */
const ProcessingSwitchControl = ({ on, busy, locked, envOff, onConfirm }) => {
    const { t } = useTranslation('vinExtraction');
    const control = (
        <Popconfirm
            title={t(on ? 'edit.confirmOff' : 'edit.confirmOn')}
            okText={t('edit.confirmOk')}
            cancelText={t('edit.confirmCancel')}
            okButtonProps={{ danger: on }}
            onConfirm={onConfirm}
            disabled={locked || busy}
        >
            <Switch
                checked={on}
                loading={busy}
                disabled={locked}
                aria-labelledby={LABEL_ID}
                aria-describedby={HELP_ID}
            />
        </Popconfirm>
    );

    if (!envOff) return control;

    return (
        <Tooltip title={t('edit.disabledByEnv')}>
            <span tabIndex={0}>{control}</span>
        </Tooltip>
    );
};

export default ProcessingSwitchControl;
